'use strict';
module.exports = require('./Textarea.vue');